import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles } from '@material-ui/core';
import React from 'react';
import FilterBubble from '@shared/Reports/FilterBubble';

const styles = {
	root: {
		width: '100%',
		minWidth: '800px',
		tableLayout: 'fixed',
		borderCollapse: 'collapse',
		'& .MuiTableCell-root': {
			paddingInline: '4px',
			paddingBlock: '0.5rem',
			fontSize: '8px',
			lineHeight: 1.2,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
			wordBreak: 'break-word',
		},
		'& .MuiTableHead-root .MuiTableCell-root': {
			fontWeight: 'bold',
			backgroundColor: '#f5f5f5',
			whiteSpace: 'pre-line',
			lineHeight: 1.1,
			paddingBlock: '0.25rem',
		},
	},
};

const PrintTable = withStyles(styles)(Table);

const RoyaltyPaymentPrintViewTable = React.forwardRef(
	({ columns, data, filters, title = 'Report', user, exportType }, ref) => {
		const filtersToShow = ['school_id', 'quarter', 'year', 'status'];

		const getPageStyles = () => {
			return `
			@page { 
				margin: 0.25in !important;
				size: portrait;
			}
			@media print {
				body {
					margin: 0;
					padding: 0;
				}
				.avoid-page-break {
					page-break-inside: avoid;
				}
				table {
					width: 100% !important;
					table-layout: fixed !important;
					margin: 0 !important;
					padding: 0 !important;
				}
				td, th {
					white-space: normal !important;
					overflow-wrap: break-word !important;
					padding: 2px 4px !important;
				}
				* {
					-webkit-print-color-adjust: exact !important;
					color-adjust: exact !important;
				}
			}
		`;
		};

		return (
			<div ref={ref}>
				<style>{getPageStyles()}</style>
				<div className="flex justify-between">
					<div>
						<img alt="logo" className="max-w-full h-auto w-128" src="/assets/images/logos/logo.png" />
					</div>
					<div>
						<p>{user?.data?.school?.name}</p>
						<p>{user?.data?.school?.address}</p>
						<p>
							{user?.data?.school?.city}, {user?.data?.school?.state?.name} {user?.data?.school?.zip_code}
						</p>
					</div>
				</div>
				<div>
					<h2>{title}</h2>
					<div className="flex items-center flex-wrap gap-10 my-10">
						<span>Applied Filters: </span>
						{Object.keys(filters)
							?.filter((filter) => filters[filter] && filtersToShow.includes(filter))
							?.flatMap((filter) => {
								const filterValues = Array.isArray(filters[filter])
									? filters[filter]
									: [filters[filter]];
								return filterValues.map((item) => {
									return (
										<FilterBubble
											className="mr-2 mb-2"
											isPdf={exportType === 'pdf'}
											isPrint={exportType === 'print'}
											key={`${filter}-${item?.value ?? item}`}
											title={item?.label ?? String(item)}
										/>
									);
								});
							})}
					</div>
				</div>
				<TableContainer
					className="shadow-none"
					component={Paper}
					elevation={0}
					style={{ width: '100%', overflowX: 'visible', overflowY: 'visible' }}
				>
					<PrintTable size="small">
						<TableHead>
							<TableRow>
								{columns.map((column, index) => {
									const isLast = index === columns.length - 1;
									return (
										<TableCell align={isLast ? 'right' : 'left'} key={column.id} padding="none">
											<span className="text-[9px]">{column.label}</span>
										</TableCell>
									);
								})}
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((row, idx) => {
								return (
									<TableRow className="avoid-page-break" key={row.school?.id ?? idx}>
										{columns.map((column, index) => {
											const isLast = index === columns.length - 1;
											return (
												<TableCell
													align={isLast ? 'right' : 'left'}
													className="py-0 px-4"
													key={column.id}
													size="small"
												>
													<span className="text-[9px]">
														{column.printRender
															? column.printRender(row)
															: column.render(row)}
													</span>
												</TableCell>
											);
										})}
									</TableRow>
								);
							})}
						</TableBody>
					</PrintTable>
				</TableContainer>
			</div>
		);
	}
);

RoyaltyPaymentPrintViewTable.displayName = 'RoyaltyPaymentPrintViewTable';

export default RoyaltyPaymentPrintViewTable;
